import scrollIntoView from 'scroll-into-view-if-needed';
import template from './uiTreeNestedNodeTemplate.html';


export default {
  name: 'uiTreeNestedNodeComponent',
  template,
  controller: uiTreeNestedNodeController,
  controllerAs: 'uiTreeNestedCtrl',
  bindings: {
    item: '<',
    userAuth: '<',
    parent: '<?',
    currentGroup: '<?',
    path: '<?',
    selectGroup: '<',
    filterQuery: '<',
    level: '<',
    parentMatch: '<?'
  }
};

/* @ngInject */
function uiTreeNestedNodeController($element, GroupService, growl, filterFilter, ModalService) {
  const vm = this;


  vm.$onChanges = $onChanges;
  vm.$onInit = $onInit;
  vm.toggle = toggle;
  vm.addNewGroup = addNewGroup;
  vm.filterGroup = filterGroup;
  vm.deleteGroupModal = deleteGroupModal;
  vm.collapseStatus = collapseStatus;


  function $onChanges({ currentGroup, path }) {
    if (currentGroup && currentGroup.currentValue === vm.item.id) {
      const autoScrollToNode = () => scrollIntoView($element[0], {
        behavior: 'smooth',
        // As little scrolling as possible to mitigate false positives in if-needed computation
        block: 'nearest',
        inline: 'nearest',
        scrollMode: 'if-needed',
      });
      _.delay(autoScrollToNode, 1000 / 2);
    }

    if (!path || path.isFirstChange()) {
      return;
    }
    if (path.currentValue?.includes(vm.item.id)) {
      vm.collapsed = false;
      // Note that we don't want to collapse groups for the user, only uncollapse
    }
  }

  function $onInit() {
    vm.collapsed = vm.level > 1;
    vm.canDelete = (vm.userAuth.canRemoveGroup && vm.level > 1) && !(vm.item.isOrgRoot || vm.item.posterityHasOrg);
  }


  function toggle(event) {
    event.stopPropagation(); // ? Will otherwise cause selection
    vm.collapsed = !vm.collapsed;
  }

  /**
   * Generate a new group (with defaulted attrs) under the given parent
   *
   * @param {object} parentGroup
   * @param {string} parentGroup.id
   * @param {Array<object>} parentGroup.subGroups
   * @param {string} parentGroup.userList
   * @returns {Promise<undefined>}
   */
  function addNewGroup({ id: parent, subGroups, userList }) {
    const growlMessage = growl.info('Adding new group...', { disableCloseButton: true });
    return GroupService.addNewGroup({
      name: `New Group ${subGroups.length + 1}`,
      parent,
      userList,
      org: parent.org
    })
      .then((group) => {
        subGroups.push(group);
        growl.success('New group added');
        vm.selectGroup(group.id);

      })
      .catch(err => void growl.error(err.error || err, { title: 'Error Adding Group:' }))
      .finally(() => void growlMessage.destroy());
  }

  function filterGroup(group, query) {
    if (!query) {
      return !vm.collapsed;
    }

    vm.thisMatch = !_.isEmpty(filterFilter([group.name], query));
    return vm.thisMatch || (!vm.collapsed && vm.parentMatch) || !_.isEmpty(filterFilter(group.subGroups, query));
  }

  function deleteGroupModal() {
    return ModalService.confirmationModal({
      modalTitle: 'Delete Group',
      optionalWarning: `Deleting ${vm.item.name} will also delete its sub-groups`,
      onConfirm: deleteGroup
    });
  }

  function deleteGroup() {
    const growlMessage = growl.info('Deleting group...', { disableCloseButton: true });
    GroupService.deleteGroup(vm.item.id)
      .then(() => {
        vm.parent.subGroups.splice(_.findIndex(vm.parent.subGroups, ['id', vm.item.id]), 1);
        vm.selectGroup(vm.parent.id);
        vm.currentGroup = null;
        growl.success(`${vm.item.name} deleted`);
      })
      .catch(({ error }) => {
        growl.error(error, { title: `Error deleting ${vm.item.name}:` });
      })
      .finally(growlMessage.destroy);
  }

  function collapseStatus() {
    return vm.item.subGroups.length
      ? vm.collapsed
        ? 'fa-caret-right'
        : 'fa-caret-down'
      : 'fa-minus flat';
  }
}
